/* eslint-disable */
import React from "react";
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { equal } from "../../../../../shared";
import { findClosestPrecedingDate, getDateWithoutFrequency, getDateId } from "../utils/dateHelpers";
import { HierarchyControl, HierarchyControlItem } from "../../../../basf-ui";

interface ControlItem extends HierarchyControlItem<number> {
  frequency: number;
}

const [yearFrequency, monthFrequency, weekFrequency] = [1, 4, 7];

export const EndDateControl: React.FC = () => {
  const [dictItems, , loadingItems] = useDictionary(dictionaryService, "calendar-origin");
  const [commodityValue] = useParameter<number | null>("@commodities");
  const [frequencyValue] = useParameter<number | null>("@frequencies");
  const [dictItemsLastWeek, , loadingLastCalendar] = useDictionary(dictionaryService, "slides-f-last-calendar", undefined, {
    attributes: "",
    unit: "",
    commodities: String(commodityValue),
    countries: "",
    slide: 33,
  });
  const lastWeekDate = dictItemsLastWeek && dictItemsLastWeek[0] ? Number(dictItemsLastWeek[0].id) : getDateId(new Date(), weekFrequency);
  const [controlItems, setControlItems] = React.useState<ControlItem[]>([]);
  const [calendarValue, setCalendarValue] = useParameter<number>("@end_date");
  const [startCalendarValue, setStartCalendarValue] = useParameter<number>("@start_date");

  React.useEffect(() => {
    if (!calendarValue || (calendarValue && getDateWithoutFrequency(calendarValue) > getDateWithoutFrequency(lastWeekDate))) {
      setCalendarValue(lastWeekDate);
    } else {
      const newDate = findClosestPrecedingDate(
        calendarValue,
        (controlItems || ([] as any)).map((item) => item.id)
      );
      const newDateFreq = findClosestPrecedingDate(
        calendarValue,
        (controlItems || ([] as any)).map((item) => item.id),
        frequencyValue
      );
      if (newDate && newDate !== calendarValue) {
        setCalendarValue(newDate);
      } else if (!newDate && newDateFreq) {
        setCalendarValue(newDateFreq);
      }
    }
  }, [controlItems, lastWeekDate, frequencyValue]);

  React.useEffect(() => {
    const newDate = findClosestPrecedingDate(
      calendarValue,
      (controlItems || ([] as any[])).map((item) => item.id),
      frequencyValue
    );
    if (newDate) {
      setCalendarValue(newDate);
    }
  }, [frequencyValue]);

  React.useEffect(() => {
    const candiatesControlItems = dictItems?.map<ControlItem>((item) => ({
      id: Number(item.id),
      parent: item.getValue<number>("parent"),
      name: item.getValue<string>("name") || "",
      frequency: item.getValue<number>("frequencyId")!,
    }));

    const [minDate, maxDate] = [20020101, getDateWithoutFrequency(lastWeekDate)];
    const datesInRengeLimit = (candiatesControlItems || []).filter((item) => {
      return minDate <= getDateWithoutFrequency(item.id as number) && getDateWithoutFrequency(item.id as number) <= maxDate;
    });
    const nextControlItems = datesInRengeLimit.reduce((result, item) => {
      if (item.frequency === yearFrequency) {
        result.push(item);
      } else if (item.frequency === monthFrequency) {
        const parentQuartal = dictItems?.find((dictItem) => equal(+dictItem.id, item.parent));
        const parentYearId = parentQuartal?.getValue<number>("parent")!;
        if (parentQuartal && parentYearId) {
          item.parent = parentYearId;
          result.push(item);
        }
      } else if (item.frequency === weekFrequency && frequencyValue === weekFrequency) {
        const paretMonth = dictItems?.find((dictItem) => equal(Number(dictItem.id), item.parent));
        if (paretMonth) {
          result.push(item);
        }
      }
      return result;
    }, [] as any);

    setControlItems(nextControlItems);
  }, [dictItems, lastWeekDate, frequencyValue]);

  const handlerChange = React.useCallback(
    (value: unknown) => {
      const weekOrMonthOrYearId = value as number;
      if (weekOrMonthOrYearId) {
        setCalendarValue(weekOrMonthOrYearId);
        if (!startCalendarValue || getDateWithoutFrequency(weekOrMonthOrYearId) < getDateWithoutFrequency(startCalendarValue)) {
          setStartCalendarValue(weekOrMonthOrYearId);
        }
      }
    },
    [dictItems, startCalendarValue, setStartCalendarValue]
  );

  const loading = loadingItems || loadingLastCalendar;

  return <HierarchyControl loading={loading} label="End date" value={calendarValue} onChange={handlerChange} items={controlItems} />;
};
